import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'

export default function EventTracker() {
  const location = useLocation()

  useEffect(() => {
    ReactPixel.pageView()
  }, [location])

  return <div />
}
